/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: { borderColor: '#b2b9bf', borderStyle: 'solid', borderWidth: 0 }
}
export default theme
